import { REDUCER_NAME } from './const'
import detailReducer from './reducer'
import { reducer as tabCommentsReducer, REDUCER_NAME as TAB_COMMENTS_REDUCER_NAME } from './tab-comments'
import { combineReducers } from 'redux'

const reducer = combineReducers({
    [REDUCER_NAME]: detailReducer,
    [TAB_COMMENTS_REDUCER_NAME]: tabCommentsReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/index.js